import { useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/HeroSection.css";
import { useNavigate } from "react-router-dom";

const EstaticeHero = () => {
 const navigate = useNavigate();
 const [loadingBtn, setLoadingBtn] = useState(null);

 const handleBookAppointment = () => {
   setLoadingBtn("book");
   navigate(
     localStorage.getItem("customerToken")
       ? "/customer/dashboard"
       : "/customer/login"
   );
 };

 const handleExploreTreatments = () => {
   setLoadingBtn("explore");
   navigate("/treatments");
 };
  return (
    <section className="ac-hero">
      <Container className="ac-hero__container">
        <Row className="ac-hero__row align-items-center">

          {/* Left — Content */}
          <Col lg={6} md={12} className="ac-hero__content-col">

            {/* Badge */}
            <div className="ac-hero__badge">
              <svg
                className="ac-hero__badge-icon"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              Dermatologist-led care
            </div>

            {/* Heading */}
            <h1 className="ac-hero__heading">
              Advanced skin & laser treatments{" "}
              <span className="ac-hero__heading-accent">
                for healthy skin.
              </span>
            </h1>

            {/* Description */}
            <p className="ac-hero__desc">
              Professional care for your skin. Modern lasers, certified
              dermatologists and personalised treatment plans — all under
              one calm, clinical roof.
            </p>

            {/* Buttons */}
            <div className="ac-hero__btns">
                <Button
                 className="ac-hero__btn-primary"
                  onClick={handleBookAppointment}
                  disabled={loadingBtn === "book"}
              >
                {loadingBtn === "book" ? (
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                ) : (
                  "Book Appointment"
                )}
            </Button>
              <Button
               className="ac-hero__btn-outline"
               onClick={handleExploreTreatments}
               disabled={loadingBtn === "explore"}
             >
               {loadingBtn === "explore" ? (
                 <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
               ) : (
                 "Explore Treatments"
               )}
             </Button>
            </div>

            {/* Stats */}
            <div className="ac-hero__stats">
              <span className="ac-hero__stars">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#E91E8C" stroke="none">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
                4.9
              </span>
              <span className="ac-hero__stats-divider">|</span>
              <span className="ac-hero__stats-text">12k+ patients</span>
              <span className="ac-hero__stats-divider">|</span>
              <span className="ac-hero__stats-text">FDA-cleared lasers</span>
            </div>

          </Col>

          {/* Right — Image Card */}
          <Col lg={6} md={12} className="ac-hero__image-col">
            <div className="ac-hero__image-wrapper">
              <div className="ac-hero__image-card">
                <img
                  src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=600&q=80"
                  alt="Estatica Clinic Treatment Room"
                  className="ac-hero__image"
                />
              </div>

              {/* Floating Badge */}
              <div className="ac-hero__floating-badge">
                <span className="ac-hero__floating-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E91E8C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </span>
                <div className="ac-hero__floating-text">
                  <span className="ac-hero__floating-label">This month</span>
                  <span className="ac-hero__floating-value">300+ happy patients</span>
                </div>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default EstaticeHero;